import { usePageTitle } from '@enroller/utils';
import { useEffect } from 'react';
import { useAuthentication } from '../hooks/useAuthentication.ts';
import { ContentWithHeaderRoute } from '../layout/ContentWithHeaderRoute.tsx';
import { Route, Routes } from 'react-router-dom';
import { Typography } from '@mui/material';
import { StudentDashboard } from '../student/application/StudentDashboard.tsx';

export const DashboardRoute = () => {
  const { setPageTitle } = usePageTitle();
  const { isLoading } = useAuthentication();
  useEffect(() => {
    setPageTitle('Dashboard');
  }, [setPageTitle]);

  if (isLoading) {
    return <Typography>Loading&hellip;</Typography>;
  }

  // TODO: return dashboard component based on the user role
  return (
    <Routes>
      <Route element={<ContentWithHeaderRoute />}>
        <Route index element={<StudentDashboard />} />
      </Route>
    </Routes>
  );
};
